import findResult, { findWithCodes } from '@/utils/resultsHelper';
import { datasetMarkdownCategories } from '../constants';

const initialState = {
  markdowns: {
    open: {
      results: [],
    },
  },
};

export const findDatasetMarkdown = ({ markdowns }, { category, code }) => (
  findResult(markdowns, category, code)
);

export const findAllDatasetMarkdowns = ({ markdowns }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(markdowns, datasetMarkdownCategories, codes);
};

export default initialState;
